/**
 * /admin/platform shell — sidebar nav + content area.
 *
 * Hosts every platform-owner page. RoleGate above this in the
 * route table guarantees only platform_owner reaches here.
 */

import { type ReactNode } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";

export function AdminShell({ children }: { children?: ReactNode }) {
  const { principal } = useAuth();

  return (
    <div className="admin-shell">
      <aside className="admin-nav">
        <div className="admin-nav-title">Platform admin</div>
        <nav>
          <NavLink to="/admin/platform/tenants" className={navClass} end>
            Tenants
          </NavLink>
          <NavLink to="/admin/platform/branding" className={navClass}>
            Branding
          </NavLink>
          <NavLink to="/admin/platform/custom-domains" className={navClass}>
            Custom domains
          </NavLink>
          <NavLink to="/admin/platform/audit" className={navClass}>
            Audit
          </NavLink>
          <NavLink to="/admin/platform/members" className={navClass}>
            Members
          </NavLink>
          <NavLink to="/admin/platform/llm/config" className={navClass}>
            LLM config
          </NavLink>
          <NavLink to="/admin/platform/llm/rates" className={navClass}>
            LLM rates
          </NavLink>
          <NavLink to="/admin/platform/llm/dashboard" className={navClass}>
            LLM dashboard
          </NavLink>
        </nav>
        <div className="admin-nav-foot">
          <div className="admin-nav-id">
            {principal?.email ?? principal?.user_id ?? "—"}
          </div>
          <Link to="/" className="admin-nav-back">
            ← Back to workspace
          </Link>
        </div>
      </aside>
      <main className="admin-main">{children ?? <Outlet />}</main>
    </div>
  );
}

function navClass({ isActive }: { isActive: boolean }) {
  return isActive ? "admin-nav-link admin-nav-link-active" : "admin-nav-link";
}
